// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import Login from './Components/Login';
import PrivacyPolicy from './Components/Privacypolicy';
import CreateAccount from './Components/CreateAccount';
import Home from './Components/Home';
import SolvePaper from './Components/SolvePaper';
import SharedPaperPage from './Components/SharedPaperPage';
import DashboardMain from './Components/DashboardMain';
import MyPaper from './Components/MyPaper';
import MySubjects from './Components/MySubjects';
import Layout from './Components/Layout';
import Settings from './Components/settings';
import PrivateRoute from "./Components/PrivateRoute";
import PageTracker from './pageTracker'; 
import DashboardStudent from "./StandeClassroom/Student/DashboardStudent";
import Onboarding from './Components/onBoarding';
import SubjectsPage from './Components/SubjectsPage';
import DashboardTeacher from "./StandeClassroom/DashboardTeacher";
import InsideClassroom from './StandeClassroom/InsideClassroom';
import { CustomPaperPage } from './StandeClassroom/custom-paper/CustomPaperPage';
import AssignmentReport from './StandeClassroom/report/AssignmentReport';
import InClassPage from './StandeClassroom/inclass/InClassPage';
import FreePaperReview from './StandeClassroom/freepaper/FreePaperReview';
import FreePaperClaim from './StandeClassroom/freepaper/FreePaperClaim';
import ClassroomsPage from './Components/ClassroomsPage';
import JoinClassPage from './Components/JoinClassPage';

function App() {
   return (
    
    <Router>
      <PageTracker />
      <Box>
        <Routes>
          <Route path="/login" element={<Login/>} />
          {/* Root now redirects to login — the marketing site lives on the
              separate stande-landing app (stande.co); this app serves app.stande.co. */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/create-account" element={<CreateAccount />} />
          <Route path="/solve-paper" element={<SolvePaper />} />
          <Route path="/my-papers/solve-paper" element={<SolvePaper />} />
          <Route path="/shared/paper/:token" element={<SharedPaperPage />} />
          <Route path="/classroom/student/dashboard" element={<DashboardStudent />} />
          <Route path="/classroom/teacher" element={<Navigate to="/classroom/teacher/dashboard" replace />} />
          <Route path="/classroom/teacher/dashboard" element={<DashboardTeacher />} />
          <Route path="/classroom/teacher/class" element={<InsideClassroom />} />
          <Route path="/classroom/teacher/create-paper" element={<CustomPaperPage />} />
          <Route path="/classroom/student/class" element={<InsideClassroom />} />
          <Route path="/classroom/report/:attemptGuid" element={<AssignmentReport />} />
          <Route path="/classroom/in-class" element={<InClassPage />} />
          {/* Landing point for the free practice paper email link. Public on
              purpose: it redirects signed-out visitors to sign up, then picks
              the journey back up after they log in. */}
          <Route path="/free-paper" element={<FreePaperClaim />} />
          {/* A class invite (email or join link). Public: signed-out visitors
              are held here while they log in or sign up. */}
          <Route path="/join/:token" element={<JoinClassPage />} />
          {/* Internal review queue for the free practice paper campaign.
              The API also checks the caller is an instructor. */}
          <Route
            path="/free-papers"
            element={
              <PrivateRoute>
                <FreePaperReview />
              </PrivateRoute>
            }
          />
          <Route path = "/my-dashboard" element={<DashboardStudent/>} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route
            path="/home"
            element={
              <Layout>
                <PrivateRoute>
                  <Home />
                </PrivateRoute>

              </Layout>
            }
          />
          <Route
            path="/subjects"
            element={
              <Layout>
                <PrivateRoute>
                  <SubjectsPage />
                </PrivateRoute>
              </Layout>
            }
          />

          <Route
            path="/dashboard"
            element={
              <Layout>
                <PrivateRoute>
                  <DashboardMain />
                </PrivateRoute>

              </Layout>
            }
          />
         <Route
            path="/my-papers"
            element={
              <Layout>
                <PrivateRoute>
                  <MyPaper />
                </PrivateRoute>
              </Layout>
            }
          />


          <Route
            path="/classrooms"
            element={
              <Layout>
                <PrivateRoute>
                  <ClassroomsPage />
                </PrivateRoute>
              </Layout>
            }
          />
          <Route
            path="/my-subjects"
            element={
              <Layout>
                <PrivateRoute>
                  <MySubjects />
                </PrivateRoute>
              </Layout>
            }
          />
          <Route
            path="/settings"
            element={
              <Layout>
                <PrivateRoute>
                  <Settings />
                </PrivateRoute>
              </Layout>
            }
          />
        </Routes>
      </Box>
    </Router>
  );
}

export default App;
